// extracted by mini-css-extract-plugin
module.exports = {"deposit":"Deposits_deposit__weBpA","title":"Deposits_title__eveTW","deposits":"Deposits_deposits__8cIpa","help":"Deposits_help__rgsp3"};